// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2706":"e9a43270","3072":"e9a43270","3091":"e9a43270","5472":"e9a43270","8153":"e9a43270"}[chunkId] + ".chunk.css";
};